import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyConnectorService } from './company-connector.service';

export type APIGetCompany = {
  id: string;
  name: string;
  addressLine1: string;
  addressLine2: string;
  logoUrl: string;
  phoneNumber: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  selectedCompany = signal(window.localStorage.getItem('selectedCompany'));

  companies = signal<APIGetCompany[]>([])
  loading = signal(false);
  companyConnectorService = inject(CompanyConnectorService);

  constructor(private router: Router) {
    this.loading.set(true);
    this.companyConnectorService.getCompanies().then((companies) => {
      this.companies.set(companies);
      this.loading.set(false);
      const selectedCompany = window.localStorage.getItem('selectedCompany');
      if (selectedCompany) {
        this.selectedCompany.set(selectedCompany);
      } else {
        this.selectedCompany.set(this.companies()[0].id);
        window.localStorage.setItem('selectedCompany', this.selectedCompany() ?? 'aoa-br');
      }
    }).catch(() => {
      this.loading.set(false);
    })
  }

  getCurrentCompany(): APIGetCompany | undefined {
    const companyId = this.selectedCompany();
    console.log(companyId);
    return this.companies().find(company => company.id === companyId);
  }

  selectCompany(companyId?: string) {
    if (companyId) {
      window.localStorage.setItem('selectedCompany', companyId);
      this.selectedCompany.set(companyId);
      this.router.navigate(['/']);
    }
  }
}
